import React, { useEffect, useState } from 'react';
import styles from "./index.module.scss";
import Config from '../../utils/Config';

function ReloadPage()
{
    const text = Config.text.reloadPage;

    //===========================================================================
    useEffect(() => {
        componentDidMount();
        return componentWillUnmount;
    }, []);
    //===========================================================================

    function componentDidMount()
    {
        window.addEventListener('resize', onResize);
        onResize();
    }

    function componentDidUpdate()
    {

    }

    function componentWillUnmount()
    {
        window.removeEventListener('resize', onResize);
    }

    function onResize()
    {
        const deviceWidth = window.innerWidth;
        const deviceHeight = window.innerHeight;
        const btnWidth = 240;
        const btnHeight = 60;

        const uiBtnRefresh = document.getElementById('btnRefresh');
        if (uiBtnRefresh) {
            uiBtnRefresh.style.position = "absolute";
            uiBtnRefresh.style.left = `${(deviceWidth - btnWidth)/2}px`;
            uiBtnRefresh.style.top = `${(deviceHeight - btnHeight)/2}px`;
            uiBtnRefresh.style.width = `${btnWidth}px`;
            uiBtnRefresh.style.height = `${btnHeight}px`;
        }
    }

    function onRefresh()
    {
        console.log('ReloadPage onRefresh');
        window.location.reload();
    }
    
    return (
        <div className={styles.reloadPage}>
            <button id="btnRefresh" className={styles.button} onClick={onRefresh}>{`${text.btnRefresh}`}</button>
        </div>
    )
}

export default ReloadPage;